/**
 * Whether the site starts in dark mode. Light is the default: dark only when the person
 * chose «Modo oscuro» ('true' stored), never because the operating system is dark.
 * src/index.html repeats this rule inline so the first paint already matches.
 */
export function temaOscuroInicial(guardado: string | null): boolean {
  return guardado === 'true';
}
